import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    saveServiceRequestSet,
    deleteServiceRequestSetById,
    getServiceRequestSetById,
    pagingServiceRequestSet
} from 'app/services/ServiceRequestSetService';
import { ServiceRequestSet } from "app/common/Model/ServiceRequestSet";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { SERVICE_REQUESTSET_TYPE } from 'app/common/LocalConst';
import { downloadTemplateServiceRequestSet, importExcelServiceRequest } from "app/services/ImportExcelService";

export default class ServiceRequestSetStore {
    listAllSRSet = [];
    searchSRSet = {...new SearchObject()};
    pageSRSet = null;
    selectedSRSet = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteSRSet = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingServiceRequestSet = (searchObject) => {
        pagingServiceRequestSet({...this.searchSRSet, ...searchObject})
            .then(({ data }) => {
                this.pageSRSet = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    setSearchObject = (newSearchObject) => {
        this.searchSRSet = {
            ...this.searchSRSet,
            ...newSearchObject,
        }
    }

    handleChangeFormSearch = (searchSRSet) => {
        this.searchSRSet = {...this.searchSRSet, ...searchSRSet, pageSize: searchSRSet?.pageSize ?? this.searchSRSet?.pageSize, pageIndex: searchSRSet?.pageSize ? 1 : (searchSRSet?.pageIndex ?? this.searchSRSet?.pageIndex)};
        this.pagingServiceRequestSet();
    }

    handleOpenFormCreateOrEdit = (srsId) => {
        if (Boolean(srsId)) {
            getServiceRequestSetById(srsId)
                .then(({ data }) => {
                    this.selectedSRSet = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedSRSet = new ServiceRequestSet();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceRequestSet = (srs, { setSubmitting }) => {
        saveServiceRequestSet(srs).then(() => {
            this.selectedSRSet = null;
            toast.success("Lưu bộ dịch vụ thành công!");
            this.handleClosePopup();
            this.pagingServiceRequestSet();
        }).finally(() => setSubmitting(false))
    }

    handleDeleteServiceRequestSet = (country) => {
        this.selectedSRSet = { id: country?.id };
        this.openConfirmDeleteSRSet = true;
    }

    handleConfirmDeleteServiceRequestSet = () => deleteServiceRequestSetById(this?.selectedSRSet?.id)
        .then(() => {
            if (this.searchSRSet.pageIndex > 1 && this.pageSRSet?.content?.length === 1) {
                this.searchSRSet.pageIndex -= 1;
            }
            toast.success("Xóa bộ dịch vụ thành công!")
            this.handleClosePopup();
            this.pagingServiceRequestSet();
        })
        .catch(error => {
            console.error(error);
            toast.error("Xóa bộ dịch vụ có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSRSet = false;
    }

    resetStore = () => {
        this.searchSRSet = new SearchObject();
        this.pageSRSet = null;
        this.selectedSRSet = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSRSet = false;
        this.listSRS = [];
        this.srsIdSet = null;
    }

    
    //for choosing service popup in TestRequestPopup.jsx 
    listSRS = [];
    srsIdSet = null;

    isValidSRS = srs => {
        if (srs && srs?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addSRS = srs => {
        if (!this.isValidSRS(srs)) return;
        this.listSRS.push(srs);
        this.srsIdSet.add(srs?.id);
    }

    initializeListSRS = list => {
        this.srsIdSet = new Set();
        this.listSRS = [];
        if (list && list?.length > 0) {
            for (let i = 0; i < list.length; i++) {
                this.addSRS(list[i]);
            }
        }
    }

    removeSRS = srs => {
        if (!this.isValidSRS(srs)) return;
        if (this.srsIdSet.has(srs?.id)) {
            this.srsIdSet.delete(srs?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = srs => {
        if (!this.isValidSRS(srs)) return;
        return this.srsIdSet.has(srs?.id);
    }

    getSRSIdSet = () => {
        return this.srsIdSet;
    }

    getListSRS = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listSRS && this.listSRS?.length > 0) {
            for (let i = 0; i < this.listSRS.length; i++) {
                const srs = this.listSRS[i];
                if (this.isExist(srs) && !bufferIdSet.has(srs?.id)) {
                    data.push(srs);
                    bufferIdSet.add(srs?.id);
                }
            }
        }
        this.listSRS = data;
        return data;
    }

    
      handleDownloadExcelTemplate = async () => {
        try {
          const response = await downloadTemplateServiceRequestSet();
    
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "LIEU_TRINH_GOI_DICH_VU.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        } catch (error) {
          console.error("Error downloading template:", error);
        }
      }
    //end

    SubmitExcelServiceRequest = (file) => {
        importExcelServiceRequest(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchSRSet = {
                ...this.searchSRSet,
                pageIndex:1
            }
            this.pagingServiceRequestSet()

        }).catch(() => {
            toast.error("Nhập excel thất bại")
        })
    }

}